import React from "react";
import Icons from "../../Constants/Icons";
import { useNavigate } from "react-router-dom";
import Colors from "../../Constants/Colors";
import { toast } from "react-toastify";
import { FiCopy } from "react-icons/fi";

const CustomUserScreen = ({
  currentUsers,
  onClickStatusChange,
  onClickFeatureStatusChange,
  Verified,
}) => {
  const navigate = useNavigate();
  const handleEditClick = (currentUsers) => {
    navigate("/UserUpdate", {
      state: {
        userId: currentUsers.userId,
        userType: currentUsers.userType,
      },
    });
  };

  const handleCopyId = (id) => {
    navigator.clipboard.writeText(id);
    toast.success("User ID copied!", id);
  };

  return (
    <div className="custom-user-list">
      <div className="scrollable-container transform_data">
        {currentUsers?.map((currentUsers, index) => (
          <div key={index} className="transaction-item cursor-pointer">
            <div className="list-user-div-container border-bottom ">
              <div className="grid-cols grid_7">
                <div
                  style={{ width: "22%" }}
                  onClick={() =>
                    navigate("/UserProfile", {
                      state: {
                        userId: currentUsers.userId,
                      },
                    })
                  }
                  className="fontSize16WithoutFlex  user_name alignItems pointer"
                >
                  <img
                    src={currentUsers.image ?? Icons.ic_default_user}
                    className="currentUsers-image"
                  />
                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <div
                      className="user_text pointer"
                      onClick={() =>
                        navigate("/UserProfile", {
                          state: {
                            userId: currentUsers.userId,
                          },
                        })
                      }
                    >
                      {currentUsers.name}
                    </div>
                    <FiCopy
                      className="copy-icon"
                      style={{ fontSize: "22px", cursor: "pointer" }}
                      title="Copy User ID"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCopyId(currentUsers.userId);
                      }}

                    />
                  </div>

                </div>
                <div
                  style={{ width: "16%", }}
                  onClick={() =>
                    navigate("/UserProfile", {
                      state: {
                        userId: currentUsers.userId,
                      },
                    })
                  }
                  className="fontSize16WithoutFlex user_name pointer"
                >
                  {currentUsers.userName}
                </div>
                <div style={{ width: "22%", }} className="user_name block">
                  <div
                    onClick={() =>
                      navigate("/UserProfile", {
                        state: {
                          userId: currentUsers.userId,
                        },
                      })
                    }
                    className="fontSize16WithoutFlex pointer alignItems"
                  >
                    <img className="sms-res" src={Icons.ic_sms} alt="new" />
                    <div className="user_text">{currentUsers.userEmail}</div>
                  </div>
                  <div
                    onClick={() =>
                      navigate("/UserProfile", {
                        state: {
                          userId: currentUsers.userId,
                        },
                      })
                    }
                    className="fontSize16WithoutFlex pointer  flex-container"
                  >
                    <img
                      className="icon_style_list "
                      alt=""
                      src={Icons.ic_call}
                    />
                    <div className="user_text">{currentUsers.mobile}</div>
                  </div>
                </div>
                <div
                  style={{ width: "9%", }}
                  onClick={() =>
                    navigate("/UserProfile", {
                      state: {
                        userId: currentUsers.userId,
                      },
                    })
                  }
                  className="fontSize16WithoutFlex user_name pointer"
                >
                  {currentUsers.birthDate}
                </div>
                <div
                  style={{ width: "7%", }}
                  onClick={() =>
                    navigate("/UserProfile", {
                      state: {
                        userId: currentUsers.userId,
                      },
                    })
                  }
                  className="fontSize16WithoutFlex user_name pointer"
                >
                  {currentUsers.userType}
                </div>
                {Verified != true && <div style={{ width: "4%", }} className="w-10">
                  <img
                    src={Icons.edit}
                    onClick={() => handleEditClick(currentUsers)}
                    className="edit-button pointer"
                  />
                </div>
                }
                <div style={{ width: "10%", }} className="user_Status user_name pointer">
                  <button
                    onClick={() => onClickStatusChange(currentUsers)}
                    className="button"
                    style={{
                      cursor: "pointer",
                      backgroundColor: currentUsers.isEnabled
                        ? Colors.mainGreen01
                        : Colors.mainRed01,
                      color: currentUsers.isEnabled
                        ? Colors.darkGreen
                        : Colors.darkRed,
                    }}
                  >
                    {currentUsers.isEnabled ? "Activate" : "Deactivate"}
                  </button>
                </div>

                <div style={{ width: "10%", }} className="user_Status user_name pointer">
                  {Verified ? (
                    <button
                      onClick={() => onClickFeatureStatusChange(currentUsers)}
                      className="button"
                      style={{
                        cursor: "pointer",
                        backgroundColor: currentUsers.isLogoVerified
                          ? Colors.mainGreen01
                          : Colors.mainRed01,
                        color: currentUsers.isLogoVerified
                          ? Colors.darkGreen
                          : Colors.darkRed,
                      }}
                    >
                      {currentUsers.isLogoVerified ? "Activate" : "Deactivate"}
                    </button>
                  ) : (
                    <button
                      onClick={() => onClickFeatureStatusChange(currentUsers)}
                      className="button"
                      style={{

                        cursor: "pointer",
                        backgroundColor: currentUsers.isFeatured
                          ? Colors.mainGreen01
                          : Colors.mainRed01,
                        color: currentUsers.isFeatured
                          ? Colors.darkGreen
                          : Colors.darkRed,
                      }}
                    >
                      {currentUsers.isFeatured ? "Activate" : "Deactivate"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomUserScreen;
